import { getAttr, getEntityId } from '../../../../features/helpers/apiHelpers';

export const mapSubjectArea = (translator) => (subjectArea) => {
  return {
    title: getAttr(subjectArea, 'name'),
    status: getAttr(subjectArea, 'isActive')
      ? translator('global.active')
      : translator('global.inactive'),
    numberOfHearings: getAttr(subjectArea, 'numOfHearings'),
    key: getEntityId(subjectArea),
  };
};
